import LocalizedStrings from "react-localization";

export const buyerStatusesStrings = new LocalizedStrings({
  en: {
    Brand: "Brand",
    Reseller: "Reseller",
    Exclude: "Exclude",
    NotMapped: "Not Mapped",
  },
  fr: {
    Brand: "Brand",
    Reseller: "Reseller",
    Exclude: "Exclure",
    NotMapped: "A Faire",
  },
});
